import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { dragNDropConstants } from '../../Globals/constants';
import { semanticColors } from '../../Globals/styles';
import { greyScaleColors } from '../../Globals/styles';

class ActivityDropComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnHeight: 0
    }
  }
  componentDidMount = () => {
    if(this.props.isLast) {
      $( window ).resize(() => {
        this.resizeDroptarget();
      });
      this.resizeDroptarget();
    }
  };
  componentWillUnmount = () => {
    $(window).unbind("resize");
  }; 
  resizeDroptarget = () => {
    let columnHeight = $('.columnContainer').height();
    this.setState({
        columnHeight
    });
  };
  getHeight = ()=> {
    let ocupied = this.props.activitiesLength * 50;
    let rest = this.state.columnHeight - ocupied - 30;
    return {height: rest};
  };


  render() {
    const { connectDropTarget, isOver, index, isLast, canDrop,
    isOnlyDropTarget, activityIsDragging } = this.props;
    let isOverAndCanDrop = canDrop && isOver;
    return  (
      <div>
        {connectDropTarget(
          <div style={
            [
              styles.dropTarget,
              index === 0 && styles.firstDropTarget,
              isOverAndCanDrop && styles.isOverDropTarget,
              isLast && styles.isLastTarget,
              isLast && this.getHeight(),
              isOnlyDropTarget && styles.isOnlyDropTarget,
              !activityIsDragging && styles.noActivityDragging
            ]
          }></div>
        )}
        <div style={[styles.dropContainer, isOverAndCanDrop && styles.isOver]}>
        </div>
    </div>)
  }
}


var styles = {
  dropTarget: {
    top: '-20px',
    height: '52px',
    position: 'absolute',
    width: '100%'
  },
  firstDropTarget: {
    top: '-15px',
    left: '0',
    height: '42px'
  },
  isOnlyDropTarget:{
    top: '0',
    height: '100%'
  },
  isOverDropTarget: {
    height: '64px'
  },
  isLastTarget: {
    top: '53px'
  },
  dropContainer: {
    transition: 'height 0.3s',
    height: '0px',
    marginTop: '0px',
    position: 'static',
    overflow: 'hidden'
  },
  isOver: {
    height: '40px',
    marginTop: '12px',
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '10px',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: semanticColors.info,
    clear: 'both'
  },
  noActivityDragging: {
    height: '0'
  }
}


const activityTarget = {
  drop(props, monitor) {
    props.onActivityDrop(monitor.getItem().id, props.columnNumber, props.index, monitor.getItem().currentColumnNumber,  monitor.getItem().currentIndex);
  },
  canDrop(props, monitor) {
    if (props.columnNumber===monitor.getItem().currentColumnNumber){
      if (props.index===monitor.getItem().currentIndex+1 || props.index===monitor.getItem().currentIndex)
        return false;
    }
    return true
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
}
  ActivityDropComponent.propTypes = {
    isOver: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    columnNumber: PropTypes.number.isRequired,
    onActivityDrop: PropTypes.func.isRequired,
    isLast: PropTypes.bool.isRequired,
    canDrop: PropTypes.bool.isRequired,
    isOnlyDropTarget: PropTypes.bool,
    activityIsDragging: PropTypes.bool.isRequired,
    activitiesLength: PropTypes.number.isRequired
  };
export default DropTarget(dragNDropConstants.ACTIVITY, activityTarget, collect)(Radium(ActivityDropComponent));


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/activityDropComponent.jsx